import { Component, OnInit, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { IEpViewModel, EpFeatureDetectionService, EpShellService } from '@epicor/ux-platform';
import { AppLocalizationStrings } from '../app.localization.strings';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  appStrings = AppLocalizationStrings;
  viewModel: IEpViewModel;

  constructor(private epShellService: EpShellService) {}

  ngOnInit() {
    this.epShellService.setTitle(this.appStrings.home);
  }
}
